import React, { useState, useEffect } from 'react';
import {
    CCard,
    CCardBody,
    CCardTitle,
    CCardText,
    CFormTextarea,
    CButton,
    CRow,
    CCol,
    CFormCheck,
} from '@coreui/react';
import DatePicker from 'react-date-picker';
import Multiselect from 'multiselect-react-dropdown';
import CookieFunctions from '../functions/CookieFunctions';
import { toast } from 'react-toastify';

export default function Safety() {

    const [body, setBody] = useState("");
    const [expiration, setExpiration] = useState(new Date());
    const [showOn, setShowOn] = useState({
        isaac: true,
        tv: true, // bolton tv
        windsorTv: true,
        oakwoodTv: true, // oakwood tv
        dp: true // driver portal
    })
    const [errors, setErrors] = useState([]);

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([]);

    const [isSending, setIsSending] = useState(false);

    // NEW: attachment state
    const [attachment, setAttachment] = useState(null);

    function getGroups() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/safety/groups/get",
            {
                method: 'GET',
                headers: myHeaders
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else if (res.status === 400) {
                throw res.text()
            }
        }).then((data) => {
            setOptions(data)
            setSelected(data)
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",

            })
        })
    }

    function onChange(selectedList) {
        setSelected(selectedList)
    }

    function sendMessage() {
        setErrors([])
        setIsSending(true)

        let tempErrors = []

        // Check values are not null 
        if (expiration === null) tempErrors.push("Must select an expiry date")
        if (!showOn.isaac && !showOn.dp && !showOn.tv && !showOn.windsorTv && !showOn.oakwoodTv) tempErrors.push("Must select at least one of the 5 options: Isaac, Bolton TV, Windsor TV, Oakwood TV, Driver Portal")
        if (selected.length === 0) tempErrors.push("Must select at least one group")
        if (body === "") tempErrors.push("Must input a message")

        // NEW: client-side size validation if attachment present
        if (attachment) {
            const maxBytes = 20 * 1024 * 1024; // 20 MB
            if (attachment.size > maxBytes) {
                tempErrors.push("Attachment is larger than 20 MB. Please contact dev@ttgi.com for assistance.");
            }
        }

        if (tempErrors.length > 0) {
            setErrors(tempErrors)
            setIsSending(false)
            return
        }

        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();
        formData.append("isaac", showOn.isaac)
        formData.append("tv", showOn.tv)
        formData.append("windsorTv", showOn.windsorTv)
        formData.append("oakwoodTv", showOn.oakwoodTv)
        formData.append("dp", showOn.dp)
        formData.append("content", body)
        formData.append("expiry", new Date(expiration).toDateString())
        formData.append("groups", selected.map((a) => a.abbr))

        // NEW: only send attachment if a file is chosen
        if (attachment && (showOn.tv || showOn.windsorTv || showOn.oakwoodTv)) {
            formData.append("attachment", attachment)
        }

        fetch("/api/safety/message/send",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then(async (res) => {
            if (res.ok) {
                toast.success("Message has been posted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored",
                });
                setBody("");
                setAttachment(null);
            } else if (res.status === 400) {
                const msg = await res.text();
                toast.error(
                    msg || "Unable to send message. Please try again.",
                    {
                        closeButton: true,
                        autoClose: true,
                        position: toast.POSITION.BOTTOM_CENTER,
                        theme: "colored",
                    }
                );
            }
        }).catch(() => {
            toast.error("Unable to send message. Please try again.", {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",
            });
        }).finally(() => {
            setIsSending(false);
        });
    }

    useEffect(() => {
        getGroups()
    }, [])

    return (
        <CCard className="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Send a Message</CCardTitle>

                <CRow className="my-2">
                    <CCol sm="12" md="4" className="my-1" style={{ display: 'flex', justifyContent: 'start' }}>
                        <CCardText className='fs-5' style={{ margin: '8px' }}>Expiration</CCardText>
                        <DatePicker
                            id='date-picker'
                            className='form-control'
                            value={expiration}
                            onChange={(date) => { setExpiration(date) }}
                            locale='en-ca'
                            format='yy-MM-dd'
                            minDetail='year'
                            yearPlaceholder='yyyy'
                            monthPlaceholder='mm'
                            dayPlaceholder='dd'
                            minDate={new Date()}
                            defaultValue={new Date()}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Isaac"
                            checked={showOn["isaac"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    isaac: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Driver Portal"
                            checked={showOn["dp"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    dp: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                </CRow>


                <Multiselect
                    showCheckbox
                    isObject={true}
                    displayValue='name'
                    selectedValues={options}
                    onRemove={onChange}
                    onSelect={onChange}
                    options={options}
                    placeholder='Select groups...'
                />

                {/* TV Grouping */}
                <CRow className="my-2">
                    <CCol sm="12">
                        <CCardText className='fs-5' style={{ margin: '8px', fontWeight: 'bold' }}>Driver Lounge TV's</CCardText>
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Bolton TV"
                            checked={showOn["tv"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    tv: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Windsor TV"
                            checked={showOn["windsorTv"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    windsorTv: e.target.checked
                                }))
                            }}
                        />
                    </CCol>
                    <CCol sm="4" md="2" style={{ margin: 'auto' }}>
                        <CFormCheck
                            className='fs-5'
                            label="Oakwood TV"
                            checked={showOn["oakwoodTv"]}
                            onChange={(e) => {
                                setShowOn((prev) => ({
                                    ...prev,
                                    oakwoodTv: e.target.checked
                                }))
                            }}
                        />
                    </CCol>

                    {/* NEW: attachment input, visible only if any TV option is selected */}
                    {(showOn.tv || showOn.windsorTv || showOn.oakwoodTv) && (
                        <CCol sm="12" md="6" className="mt-3">
                            <CCardText className='fs-6' style={{ margin: '8px' }}>
                                Optional attachment for Driver Lounge TV (pdf, ppt, video, etc.) - max 20 MB
                            </CCardText>
                            <input
                                type="file"
                                className="form-control"
                                onChange={(e) => {
                                    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
                                    setAttachment(file);
                                }}
                            />
                        </CCol>
                    )}
                </CRow>

                <CFormTextarea
                    placeholder="Type your message here (maximum 1000 characters)"
                    value={body}
                    onChange={(e) => { setBody(e.target.value) }}
                    style={{ marginBottom: '10px', marginTop: '8px', minHeight: '200px' }}
                />
                {errors.length !== 0 ?
                    <CCol sm="12">
                        {errors.map((error, i) => {
                            return <CCardText key={i} style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</CCardText>
                        })}
                    </CCol> : null}

                <CButton
                    color="primary"
                    className="mt-3"
                    onClick={sendMessage}
                    disabled={isSending}
                >
                    Submit
                </CButton>
            </CCardBody>
        </CCard>
    );
}
